import { render, staticRenderFns } from "./ActiveMovementBatch.vue?vue&type=template&id=b95a3702"
import script from "./ActiveMovementBatch.vue?vue&type=script&lang=js"
export * from "./ActiveMovementBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports